export default __webpack_public_path__ + "static/media/Not found@2x.032ee8f8.png";